import { useLocation, useNavigate } from "react-router-dom";
import { useState, useRef, useEffect, useContext } from "react";
import styles from "./styles/BottomNav.module.css";
import { FaPlus, FaChalkboard, FaRegBookmark, FaBars } from "react-icons/fa";
import { RiHomeLine } from "react-icons/ri";
import MobileNavbarMenu from '../navbar/MobileNavbarMenu';
import AuthContext from '../../../context/AuthContext';

// Bottom navigation used for mobile

const BottomNav = () => {
  const { user } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef();

  const isActive = (path) => location.pathname === path;

  const handleClickClassrooms = () => {
    navigate("/my-classrooms");
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setShowMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <nav className={styles.bottomNav}>
      <button
        className={`${styles.navItem} ${isActive("/home") ? styles.active : ""}`}
        onClick={() => navigate("/home")}
      >
        <RiHomeLine className={styles.icon} />
        <span>Home</span>
      </button>

      <button
        className={`${styles.navItem} ${isActive("/saved") ? styles.active : ""}`}
        onClick={() => navigate("/saved")}
      >
        <FaRegBookmark className={styles.icon} />
        <span>Saved</span>
      </button>

      <button className={styles.createButton} onClick={() => navigate("/create")}>
        <svg
          className={styles.createIcon}
          viewBox="0 0 24 24"
          fill="none"
          stroke="white"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="12" y1="4.5" x2="12" y2="19.5" />
          <line x1="4.5" y1="12" x2="19.5" y2="12" />
        </svg>
      </button>

      <button
        className={`${styles.navItem} ${isActive("/my-classrooms") ? styles.active : ""}`}
        onClick={handleClickClassrooms}
      >
        <FaChalkboard className={styles.icon} />
        <span>Classrooms</span>
      </button>

      <div className={styles.menuWrapper} ref={menuRef}>
        <button
          className={styles.navItem}
          onClick={() => setShowMenu(prev => !prev)}
        >
          <FaBars className={styles.icon} />
          <span>More</span>
        </button>

        {showMenu && (
          <MobileNavbarMenu setShowMenu={setShowMenu} user={user} />
        )}
      </div>
    </nav>
  );
};

export default BottomNav;